import type { Site } from '~/types'

export function useSite() {
  const sites = useState<Site[]>('sites', () => [])
  const siteId = useState<string | null>('site-id', () => null)

  const site = computed(() => sites.value.find((s) => s.siteId === siteId.value) as Site)

  return { sites, siteId, site }
}
